import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Link } from 'react-router';

import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { userIdentityShape } from '@bibliocommons/bc-prop-types';
import { Arrows } from '@bibliocommons/deprecated-base-icons';

import './UserHeaderNav.scss';

export class UserHeaderNav extends React.PureComponent {
  render() {
    const { renderHeading, renderIcon, isCurrentUser, items, userIdentity, intl } = this.props;
    const classNames = cn('cp-user-header-nav', {
      'home-patron': userIdentity.get('homePatron'),
      'main-nav': items.size <= 0
    });
    const exitLabel = isCurrentUser ? (
      <FormattedMessage id="section_title_my_profile" />
    ) : (
      <FormattedMessage id="section_title_users_profile" values={{ username: userIdentity.get('name') }} />
    );
    const profileURL = `/user_profile/${userIdentity.get('id')}`;

    return (
      <div className={classNames}>
        <a className="exit-link" href={profileURL} data-key="exit-link">
          <Arrows.Long.Left color="#fff" />
          <ScreenReaderMessage>{exitLabel}</ScreenReaderMessage>
        </a>

        <span className="heading">
          {renderIcon()} {renderHeading()}
        </span>

        <ul className="links-list hidden-xs">
          {items.map(navItem => {
            const shelfName = navItem.get('shelfName');
            const itemCount = navItem.get('itemCount');
            const formattedShelfName = intl.formatMessage({
              id: `label_${shelfName}_shelf`
            });
            const ariaCurrent = navItem.get('active') ? 'page' : null;
            const linkClassNames = cn({ active: navItem.get('active') });

            /* eslint-disable */
            return (
              <li key={navItem.get('key')} className="user-header-nav-item">
                <Link
                  to={navItem.get('link')}
                  data-key={navItem.get('dataKey')}
                  className={linkClassNames}
                  aria-label={`${formattedShelfName} (${itemCount} items)`}
                  aria-current={ariaCurrent}
                >
                  {navItem.get('label')}
                </Link>
              </li>
            );
            /* eslint-enable */
          })}
        </ul>
      </div>
    );
  }
}

const itemShape = ImmutablePropTypes.mapContains({
  key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  link: PropTypes.string.isRequired,
  shelfName: PropTypes.string.isRequired
});

UserHeaderNav.propTypes = {
  renderHeading: PropTypes.func.isRequired,
  renderIcon: PropTypes.func.isRequired,
  isCurrentUser: PropTypes.bool,
  items: ImmutablePropTypes.iterableOf(itemShape).isRequired,
  userIdentity: userIdentityShape.isRequired
};

export default injectIntl(UserHeaderNav);
